import request from '../utils/request.js';
let apiConfig = null;
try {
  apiConfig = require('../../src/config/api').default;
} catch (e) {
  // 文件不存在时忽略错误
}
const baseUrl = apiConfig?.VUE_APP_GIAM_Common || process.env.VUE_APP_GIAM_Common;
// 设置定时开启
export function settingAdScheduleOpenTask(data) {
  return request({
    baseURL: baseUrl,
    url: '/ads/settingAdScheduleOpenTask',
    method: 'post',
    data: data,
    timeout: 0,
    transformRequest: [
      function (data) {
        return data;
      },
    ],
  });
}

// 定时改出价
export function settingAdScheduleUpdateBidTask(data) {
  return request({
    baseURL: baseUrl,
    url: `/ads/settingAdScheduleUpdateBidTask`,
    method: 'post',
    data: data,
    timeout: 0,
    transformRequest: [
      function (data) {
        return data;
      },
    ],
  });
}

// 定时改预算
export function settingAdScheduleUpdateBudgetTask(data) {
  return request({
    baseURL: baseUrl,
    url: `/ads/settingAdScheduleUpdateBudgetTask`,
    method: 'post',
    data: data,
    timeout: 0,
    transformRequest: [
      function (data) {
        return data;
      },
    ],
  });
}
